
import { request } from '../util/request'
export function submitOrder(data = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/appointResource/appoint`,
    method: 'post',
    data,
    loadingConfig
  })
}